@if (categoriesTree?.length) {
  <p-treeselect
    class="w-full md:w-80"
    [options]="categoriesTree"
    [filter]="true"
    [metaKeySelection]="false"
    [(ngModel)]="selectedNodes"
    (ngModelChange)="selectedNodesChanenged($event)"
    selectionMode="checkbox"
    display="chip"
    [propagateSelectionUp]="false"
    [placeholder]="'PRODUCT_FILTER_SELECT_CATEGORIES' | translate"
    [appendTo]="appendTo()"
    (onNodeUnselect)="nodeUnselected($event)"
    (onNodeSelect)="nodeSelected($event)"
  >
    <ng-template let-node pTemplate="default">
      <span class="flex items-center">
        {{ node.label }} (<span class="text-success-600 font-bold">{{
          node.data?.selectedProducts || '0'
        }}</span
        >/{{ node.data?.productCount + node.data?.nestedProductCount || 0 }})
      </span>
    </ng-template>
  </p-treeselect>
}
